import { render, staticRenderFns } from "./IconPhone.vue?vue&type=template&id=634de064&scoped=true&"
import script from "./IconPhone.vue?vue&type=script&lang=js&"
export * from "./IconPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634de064",
  null
  
)

export default component.exports